// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__S4fNr","switch__item":"styles_switch__item__QFYc9","switch__item_active":"styles_switch__item_active__SBj3C"};